import { render, staticRenderFns } from "./TypicalAchievement.vue?vue&type=template&id=0889d96b&scoped=true&"
import script from "./TypicalAchievement.vue?vue&type=script&lang=js&"
export * from "./TypicalAchievement.vue?vue&type=script&lang=js&"
import style0 from "./TypicalAchievement.vue?vue&type=style&index=0&id=0889d96b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889d96b",
  null
  
)

export default component.exports